import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import useApiHttp from '../hooks/use-http';
import { Box, Divider } from '@mui/material';
import PageLoader from '../components/UI/Loader/PageLoader';

const RecommendationUI = ({ clusters }) => {
    return (
        <div>
            {clusters.map((cluster, i) => (
                <>
                    <div key={cluster.targetClusterId}>

                        <h3>Target Cluster: {cluster.targetClusterId}</h3>

                        <img
                            src={cluster.mediaUrl}
                            width={150}
                            style={{ borderRadius: '50%', aspectRatio: 1, maxWidth: '200px', objectFit: 'cover' }}
                        />

                        <p>Total Suggestions: {cluster.totalSuggestions}</p>

                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                            {cluster.recommendations.map((rec) => (
                                <div
                                    key={rec.recommendationId}
                                    style={{
                                        border: "1px solid #ccc",
                                        padding: 10,
                                        width: 120
                                    }}
                                >
                                    <h5>{rec?.sourceClusterId}</h5>
                                    <img src={rec.mediaUrl} width={100} />
                                    <p>{rec.confidenceLevel}</p>
                                    <p>{rec.confidenceScore}</p>
                                </div>
                            ))}
                        </div>

                    </div>
                    {clusters.length - 1 !== i &&
                        <Box my={4}>
                            <Divider />
                        </Box>
                    }
                </>
            ))}
        </div>
    );
};

export default function Recommendation() {
    const { id: eventId } = useParams();
    const [recommendationList, setRecommendationList] = useState([])

    const { sendRequest: getRecommendationList, isLoading: recommendationListLoading } =
        useApiHttp();

    const getRecommendationListHandler = (page) => {
        getRecommendationList(
            {
                url: `events/${eventId}/recommendation?page=0&size=10`,
                method: "GET",
                base: "MEDIA",
            },
            null,
            (data) => {
                setRecommendationList(data?.data?.clusters)
            },
            (err, data) => {

            }
        )
    }

    useEffect(() => {
        getRecommendationListHandler()
    }, [])
    return (
        <>
            <Box mb={3}>
                <div>Recommendation</div>
            </Box>
            <Box>
                <RecommendationUI clusters={recommendationList} />
            </Box>
            {recommendationListLoading && <PageLoader open={recommendationListLoading} />}
        </>
    )
}
